import type { IconData } from '@stacksjs/iconify-core'

export const trashAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1zM12.83 5H3.17l.722 13h8.216zM2 2v1h12V2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default trashAlt
